<template>
  <div>
    <!-- 头部 开始 -->
    <header class="module-layer">
      <div class="module-layer-content">
        <div class="logo">
          <p>文物列表</p>
        </div>
      </div>
    </header>
    <header class="module-layer-mobile">
      <div class="module-layer-content-mobile">
        <div class="back" @click="back">
          <p class="iconfont">&#xe685; 列表</p>
        </div>
        <span class="iconfont more" @click="show = !show">&#xe60d;</span>
      </div>
    </header>
    <!-- 头部 结束 -->

    <!-- 搜索 弹出层 -->
    <search v-if="show" @closed="close" @search="search"></search>

    <!-- 主体 开始 -->
    <div class="layout-container" style="min-height: 600px;">
      <div class="cp_blk02" style>
        <span id="search_result_id">
          <p>
            <a href="javascript:;" value="16">
            </a>
          </p>
        </span>
      </div>
      <div class="table_box">
        <h2>
          <div class="h2_info">文物号</div>
          <div class="h2_info">文物名称</div>
          <div class="h2_info">图片</div>
          <div class="h2_info">状态</div>
        </h2>

        <!-- 文物列表 -->
        <item v-for="(item, index) in items" :item="item" :key="index"></item>
      </div>
    </div>
    <!-- 主体 结束 -->
  </div>
</template>

<script>
import { getProductList } from "@/api/api";
import Item from "../components/Item"; // 引入子组件
import Search from "../components/Search"; // 引入子组件（搜索）

export default {
  components: { Item, Search },
  data() {
    return {
      show: false,
      params: {},
      items: []
    };
  },
  created() {
    // example 127.0.0.1/list/1, id = 1
    const id = this.$route.params && this.$route.params.id;
    this.params = { category_id: id };
    this.fetchData(this.params);
  },
  methods: {
    fetchData(params) {
      getProductList(params).then(response => {
        this.items = response.data;
      });
    },
    back() {
      // 返回上一页
      this.$router.push({
        path: `/`
      });
    },
    close(show) {
      this.show = show;
    },
    search(keyword, status) {
      // 根据条件搜索
      this.params.keyword = keyword;
      this.params.status = status;
      this.fetchData(this.params);
    }
  }
};
</script>

<style scoped>
.module-layer-content {
  background-color: #dedede;
}
.layout-container {
  background-color: #f7f8f8;
}
.image_icon {
  width: 25px;
  height: auto;
  position: relative;
  top: -2px;
  border-radius: 2px;
}
.back p {
  color: #c1925b;
}
.more {
  position: absolute;
  line-height: 0.43rem;
  right: 0.12rem;
  color: #c1925b;
  font-size: 0.12rem;
}
</style>
